<script setup lang="ts">
defineOptions({
	name: 'ConsentSection',
})

const { t: $t } = useI18n()

const firstHtml = computed(() => {
	return $t(
		'Gaveta Decimal uses the tool {cookie} to manage user cookie consent when accessing the Platform. This consent is requested upon accessing the Platform.',
		{
			cookie: `<span class="font-semibold">CookieYes</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:check-box-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('How is your consent collected') }}?
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p>
				{{
					$t(
						'Consent can be withdrawn at any time without affecting the lawful use of cookies prior to withdrawal. Essential functionalities may, however, be limited if certain cookies are disabled',
					)
				}}
			</p>
		</div>
	</section>
</template>
